var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyR = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.5 29.18",
    width: 16,
    height: 16,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0, 0, 0, 0.54)",
    className: "cls-1",
    d: "M20.16,22.83a5,5,0,0,0,5-5V7.56h-2.5V17.84a2.5,2.5,0,0,1-2.5,2.49H7.56v2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0, 0, 0, 0.54)",
    className: "cls-1",
    d: "M5.06,20.33H5a2.5,2.5,0,0,1-2.5-2.49V5A2.5,2.5,0,0,1,5,2.5H20.16A2.5,2.5,0,0,1,22.66,5v.06h2.5V5a5,5,0,0,0-5-5H5A5,5,0,0,0,0,5V17.84a5,5,0,0,0,5,5h.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0, 0, 0, 0.54)",
    className: "cls-1",
    d: "M26.51,29.18H11.34a5,5,0,0,1-5-5V11.34a5,5,0,0,1,5-5H26.51a5,5,0,0,1,5,5V24.18A5,5,0,0,1,26.51,29.18ZM11.34,8.84a2.5,2.5,0,0,0-2.5,2.5V24.18a2.5,2.5,0,0,0,2.5,2.5H26.51A2.5,2.5,0,0,0,29,24.18V11.34a2.5,2.5,0,0,0-2.49-2.5Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyR);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMS41IDI5LjE4IiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPjx0aXRsZT5Db3B5PC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGZpbGw9InJnYmEoMCwgMCwgMCwgMC41NCkiIGNsYXNzPSJjbHMtMSIgZD0iTTIwLjE2LDIyLjgzYTUsNSwwLDAsMCw1LTVWNy41NmgtMi41VjE3Ljg0YTIuNSwyLjUsMCwwLDEtMi41LDIuNDlINy41NnYyLjVaIi8+PHBhdGggZmlsbD0icmdiYSgwLCAwLCAwLCAwLjU0KSIgY2xhc3M9ImNscy0xIiBkPSJNNS4wNiwyMC4zM0g1YTIuNSwyLjUsMCwwLDEtMi41LTIuNDlWNUEyLjUsMi41LDAsMCwxLDUsMi41SDIwLjE2QTIuNSwyLjUsMCwwLDEsMjIuNjYsNXYuMDZoMi41VjVhNSw1LDAsMCwwLTUtNUg1QTUsNSwwLDAsMCwwLDVWMTcuODRhNSw1LDAsMCwwLDUsNWguMDZaIi8+PHBhdGggZmlsbD0icmdiYSgwLCAwLCAwLCAwLjU0KSIgY2xhc3M9ImNscy0xIiBkPSJNMjYuNTEsMjkuMThIMTEuMzRhNSw1LDAsMCwxLTUtNVYxMS4zNGE1LDUsMCwwLDEsNS01SDI2LjUxYTUsNSwwLDAsMSw1LDVWMjQuMThBNSw1LDAsMCwxLDI2LjUxLDI5LjE4Wk0xMS4zNCw4Ljg0YTIuNSwyLjUsMCwwLDAtMi41LDIuNVYyNC4xOGEyLjUsMi41LDAsMCwwLDIuNSwyLjVIMjYuNTFBMi41LDIuNSwwLDAsMCwyOSwyNC4xOFYxMS4zNGEyLjUsMi41LDAsMCwwLTIuNDktMi41WiIvPjwvZz48L2c+PC9zdmc+";